<template>
    <section>
        <v-card style="margin: 26px;" v-if="Activities.length > 0">
            <v-layout @click="OpenActivityDetails(item)" row style="cursor: pointer;padding: 18px;border-bottom: 1px solid #d3d3d39e;" v-for="item in Activities" :key="item._id">
                <v-flex xs10 style="font-size: 18px;font-weight: 400;">
                    <v-icon v-if="item.Activity_Type == 'purchased_course'" style="padding: 0px 12px;">payment</v-icon> 
                    <v-icon v-if="item.Activity_Type == 'registered' && item.User_Type == 'User'" style="padding: 0px 12px;">people</v-icon>
                    <v-icon v-if="item.Activity_Type == 'registered' && item.User_Type == 'Trainer'" style="padding: 0px 12px;">how_to_reg</v-icon>
                    {{ item.Message }}
                </v-flex>
                <v-flex xs2 style="font-size: 10px;padding-top: 12px;"> {{ new Date(item.Created_On).toLocaleTimeString() }} on {{ new Date(item.Created_On).toDateString() }} </v-flex>
            </v-layout>
        </v-card>
        <v-card v-else style="margin: 26px;text-align:center;">
            <v-card-title>No Activities Found</v-card-title>
        </v-card>
        <app-transaction-details ref="DisplayDetails" :dialog='OpenTransactionDailog' @close='closedialog'></app-transaction-details>
    </section>
</template>
<script>
import appTransactionDetails from '../views/dialogs/ActivityTransactionDetails'
export default {
    components:{
        appTransactionDetails
    },
    data(){
        return {
            Activities : [],
            OpenTransactionDailog : false
        }
    },
    methods:{
        OpenActivityDetails(item){

            if(item.Activity_Type == 'purchased_course'){

                this.GetPurchaseDetails(item['Reference_Id'])
                this.OpenTransactionDailog = true
            }
        },
        closedialog(){
            this.OpenTransactionDailog = false
        },
        GetPurchaseDetails(id){

            this.$http.post(`${this.$store.getters.GetProductionUrl}/payment/transactiondetails`,{"Transaction_Ref_Id": id })
                    .then(response =>{
                        
                        this.$refs.DisplayDetails.DisplayDetails(response['data']['response'])
                        
                    })
                    .catch(err =>{

                        this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Error While Fetching Data","Color":"red","Close": false });
                    })
        }
    },
    mounted(){

        this.$http.post(`${this.$store.getters.GetProductionUrl}/analysis/getactivities`)
                    .then(response =>{
                        
                        this.Activities = response['data']['response']
                        this.$eventHub.$emit("LOADING",'false')
                        
                    })
                    .catch(err =>{

                        this.$eventHub.$emit("LOADING",'false')
                        this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Error While Fetching Data","Color":"red","Close": false });
                    
                    })
    }
}
</script>
<style scoped>

</style>